import { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import instance from "../../utils/axiosInstance";
import { EncryptData } from "../../constants/api-urlConstants";
import {
  apiBasePathSearch, limitedUserSubscriptionUrl, proUserSubscriptionUrl
} from "../../constants/env-url";
import { Box, CircularProgress } from "@mui/material";

const EmbeddedCheckout = (props: any) => {

	const { userData, access } = props;
	const [fsCalled, setFsCalled] = useState(false);
  const [loading, setLoading] = useState(true);

	useEffect(() => {
		if(!fsCalled) {
			showlimitedUserSubscription(userData);
			setFsCalled(true);
		}
	}, [userData, fsCalled]);

	const showlimitedUserSubscription = (userData: any) => {
    (window as any)?.fastspring.builder.reset();
    const mySession = {
      contact: {
        email: userData?.email,
        firstName: userData?.firstName?.trim?.(),
        lastName: userData?.lastName?.trim?.(),
      },
      items: [
        { product: access === 'pro' ? proUserSubscriptionUrl : limitedUserSubscriptionUrl , quantity: 1, pricing: { quantityBehavior: 'lock' }, removable: false }
      ]
    };
    encryptData(mySession).then((res) => {
      const data = res?.data;
      const securePayload = data.securePayload;
      const secureKey = data.secureKey;
      (window as any)?.fastspring.builder.secure(securePayload, secureKey);
      (window as any)?.fastspring?.builder?.checkout();
    }).catch(() => {}).finally(() => {
      setTimeout(() => {
        setLoading(false);
      }, 3000);
    });
  }

  const encryptData = (payload: any): Promise<AxiosResponse<any, any>> => {
    const apiUrl = `${apiBasePathSearch}${EncryptData}`;
    return instance.post(apiUrl, payload);
  }

	return (
		<Box sx={{position: 'relative', height: '100%', width: '100%' }}>
      {loading &&
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <Box sx={{position: 'absolute', top: '35%', zIndex: 99}}>
            <CircularProgress size={32} />
          </Box>
        </Box>
      }
			<div id="fsc-embedded-checkout-container" style={{ position: "relative" }} />
		</Box>
	);
};

export default EmbeddedCheckout;